import {handleActions} from 'redux-actions';

import {parseBreakpointsData} from '@pluto/parse-breakpoints-data';
import {
    CONTENT_ITEM_SET,
    EDIT_CONTENT_ITEM_SET,
    CONTENT_ITEM_RESET,
} from './ContentItemActions';

export const setItem = (state: any, {payload}:any) => {
    if (payload) {
        const {metaData, assets} = payload;
        const {sourceVideo} = assets;
        const {techData} = sourceVideo;
        const {breakpointFrames} = metaData;
        const breakpoints = parseBreakpointsData(techData, breakpointFrames);
        const data = {
            metaData,
            assets,
            breakpoints,
        };
        
        return {
            isLoading: false,
            data,
        };
    }
    
    return {
        ...state,
        isLoading: false,
    };
};

export const resetItem = () => {
    return initialState;
};

export const initialState = {
    data: null,
    isLoading: true,
};

const handlers = {
    [CONTENT_ITEM_SET]: setItem,
    [CONTENT_ITEM_RESET]: resetItem,
    [EDIT_CONTENT_ITEM_SET]: setItem,
};

export default handleActions(handlers, initialState);
